import { InboundTenderList } from "../../../datafusion/src/InboundTenderList";
import { IntercompanySlideout } from "../../../datafusion/src/IntercompanySlideout";
import { OutboundTenderList } from "../../../datafusion/src/OutboundTenderList";
import { Button, DataSource, Label, Layout, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutShipmentStatusSlideout extends Layout {
    buttonAddNewStatus: Button;
    buttonAdditionalInformationInbound: Button;
    buttonAddtionalInformationOutbound: Button;
    labelInTenders: Label;
    labelInboundShipmentStatus: Label;
    labelIntercompany: Label;
    labelOutTenders: Label;
    labelOutboundShipmentStatus: Label;
    layoutInboundTender: InboundTenderList;
    layoutIntercompany: IntercompanySlideout;
    layoutOutboundTender: OutboundTenderList;
    sourceDelayCode: DataSource;
    sourceEdiCustomer: DataSource;
    sourceEdiMapError: DataSource;
    sourceEdiMovementCarrier: DataSource;
    sourceEdiMovementOrder: DataSource;
    sourceEdiMovementOrderIc: DataSource;
    sourceEdiOrder: DataSource;
    sourceEdistatus: DataSource;
    tabInbound: Tab;
    tabInboundTender: Tab;
    tabIntercompany: Tab;
    tabOutbound: Tab;
    tabOutboundTender: Tab;
    tableInbound: Table;
    tableOutbound: Table;
    tabsetDataFusion: Tabset;
}
